import { Component, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { IonContent, NavParams, Platform } from "@ionic/angular";
import { fromEvent, Subscription } from "rxjs";
import { Navigator } from "src/app/components/menu/navigator";
import { BannerService } from "src/app/services/banner/banner.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { isUndefined } from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { DepositService } from "src/app/services/cashier/deposit.service";
declare var window: any;

@Component({
  selector: "page-deposit-interac-action",
  templateUrl: "deposit-interac-action.html",
})
export class DepositInteracActionPage extends CashierBase implements OnInit {
  @ViewChild("Content") content: IonContent;

  private checkDepositWasCalled = false;
  private amount: number;
  private paymentRequestID;

  public iframe_url;

  public bonusID: string;
  public bonusCode: string;
  public params;
  public isMobile;
  public check_deposit_complete: boolean = false;
  public check_deposit_result: string;
  public loading: boolean = true;
  public url;
  public interacCallBack: Subscription;
  public checkInteracPaymentID;
  public interacReturn;

  constructor(
    public platform: Platform,
    private sanitizer: DomSanitizer,
    protected userSessionProvider: UserSessionService,
    protected navParams: NavParams,
    protected utils: UtilsService,
    private depositService: DepositService,
    protected events: EventsService,
    protected bannerProvider: BannerService,
    private navigator: Navigator
  ) {
    super();
    this.url = navParams.get("params");
    this.checkInteracPaymentID = navParams.get("interacReturn");
    this.amount = this.navParams.get("amount");
    this.paymentRequestID = this.navParams.get("paymentRequestID");
    this.bonusCode = this.navParams.get("bonusCode");
    this.bonusID = this.navParams.get("bonusID");

    if (this.checkInteracPaymentID) {
      const splitHashstr = this.checkInteracPaymentID?.split('?');
      const paymentRequestID = splitHashstr[1]?.split('=')[1];
      if (!!paymentRequestID) {
        this.checkDeposit({
          id: paymentRequestID,
          params: {
            amount: (this.amount ? this.amount : '')
          }
        });
      }
    }

    this.interacCallBack = fromEvent(window, 'message').subscribe((event: any) => {
      if (event.data.id) {
        this.checkDeposit(event.data);
        this.unsubscribe();
      }
    });
  }

  ngOnInit() {
    this.iframe_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  ionViewDidLoad() {
    this.isMobile = (this.platform.is('cordova')) ? true : false;
    if (this.interacReturn) {
      let paymentRequestID = this.interacReturn.identifier;
      let hash = document.location.hash;
      if (!!paymentRequestID && hash.indexOf('#interac-return')) {
        this.checkDeposit({
          id: paymentRequestID,
          params: {
            amount: this.amount
          }
        });
      }
    }
  }

  formatAmount(amount) {
    return parseFloat(amount).toFixed(2).toString();
  }

  checkDeposit(data) {
    // event.data.id
    let paymentRequestId = data.id;
    if (!isUndefined(paymentRequestId)) {
      this.params = data.params;
      this.params.amount = parseFloat(this.params.amount);

      this.depositService.checkDepositStatus(paymentRequestId).subscribe(
        (response) => {
          this.check_deposit_complete = true;
          this.checkDepositWasCalled = true;
          console.log(response);
          if (!isUndefined(response.payload)) {
            switch (response.payload.status) {
              case 'APPROVED':
                //this.check_deposit_result = 'AP';
                //setTimeout(() => this.bannerProvider.fetchAllBanners(), 1000);
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  { status: true, flag: "interac" }
                );
                break;
              case 'IN PROCESS':
                //this.check_deposit_result = 'IP'
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  {
                    status: false,
                    flag: "interac",
                    message:
                      "Your deposit transaction is still in progress.<br/>Please check your account or contact customer support.",
                  }
                );
                break;
              case 'CANCELLED':
                //this.check_deposit_result = 'CA';
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  {
                    status: false,
                    flag: "interac",
                    message:
                      "Your deposit transaction did not succeed.",
                  }
                );
                break;
              default:
                //this.check_deposit_result = 'FAIL';
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  {
                    status: false,
                    flag: "interac",
                    message:
                      "Your deposit transaction could not be processed.",
                  }
                );
                break;
            }
          } else {
            //this.check_deposit_result = 'FAIL'
            this.navigator.navigateTo(
              "DepositSuccessFailureComponent",
              {},
              { status: false, flag: "interac" }
            );
          }
        },
        (error) => {
          //this.check_deposit_complete = true;
          //this.check_deposit_result = 'FAIL'
          this.navigator.navigateTo(
            "DepositSuccessFailureComponent",
            {},
            { status: false, flag: "interac" }
          );
        }
      );
    } else {
      //this.check_deposit_complete = true;
      //this.check_deposit_result = 'FAIL'
      this.navigator.navigateTo(
        "DepositSuccessFailureComponent",
        {},
        { status: false, flag: "interac" }
      );
    }
  }

  closeDialog() {
    this.navigator.toLobby();
  }

  closeWindow = () => {
    window._window_has_closed = true;
    window.close();
  }

  onBack = () => {
    if (this.checkDepositWasCalled) {
      if (!!this.navParams.get("navigateBackPage")) {
        let navigateBackPage = this.navParams.get("navigateBackPage");
        this.navigator.navigateTo(navigateBackPage);
      } else {
        this.navigator.back();
      }
    } else {
      this.checkDeposit({
        id: this.paymentRequestID,
        params: {
          amaunt: this.amount
        }
      });
    }
  }

  loadiFrame() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  unsubscribe() {
    this.interacCallBack.unsubscribe();
  }
}
